import type { TRouteObject } from "@ch/helpers/utils/types";
import ErrorPage from "@ch/pages/ErrorPage";
import HealthPassportPageLazy from "@ch/pages/HealthPassportPage";
import EyeExamHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/EyeExam";
import FootExamHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/FootExam";
import HealthConditionHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/HealthCondition";
import MyLabsHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/Labs";
import MedicationHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/Medication";
import PrescriptionHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/Prescription";
import PrescriptionDetailsPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/Prescription/PrescriptionDetailsPage.tsx";
import MyPharmacyHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/Pharmacy";
import MyProviderHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/Provider";
import PastMedicalProceduresHistoryPageLazy from "@ch/pages/HealthPassportPage/singleHistoryPages/procedures";
import NotFoundPage from "@ch/pages/NotFoundPage";
import { HealthPassportPathsEnum, HealthPassportRoutesEnum } from "./enums";

const HealthPassportRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HealthPassportPageLazy />,
      },
      {
        path: HealthPassportPathsEnum.HEALTH_CONDITION_HISTORY,
        element: <HealthConditionHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Health Condition History",
          }),
          crumb: () => ({
            title: "Health Condition History",
            route: HealthPassportRoutesEnum.HEALTH_CONDITION_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.EYE_EXAM_HISTORY,
        element: <EyeExamHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Eye Exam History",
          }),
          crumb: () => ({
            title: "Eye Exam History",
            route: HealthPassportRoutesEnum.EYE_EXAM_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.FOOT_EXAM_HISTORY,
        element: <FootExamHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Foot Exam History",
          }),
          crumb: () => ({
            title: "Foot Exam History",
            route: HealthPassportRoutesEnum.FOOT_EXAM_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.MEDICATION_HISTORY,
        element: <MedicationHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Medication History",
          }),
          crumb: () => ({
            title: "Medication History",
            route: HealthPassportRoutesEnum.MEDICATION_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.PRESCRIPTION_HISTORY,
        element: <PrescriptionHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Prescription History",
          }),
          crumb: () => ({
            title: "Prescription History",
            route: HealthPassportRoutesEnum.PRESCRIPTION_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.PRESCRIPTION__DETAILS,
        element: <PrescriptionDetailsPageLazy />,
        handle: {
          meta: () => ({
            title: "Prescription Details",
          }),
          crumb: () => ({
            title: "Prescription Details",
            route: HealthPassportRoutesEnum.PRESCRIPTION_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.MY_LABS_HISTORY,
        element: <MyLabsHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "My Labs History",
          }),
          crumb: () => ({
            title: "My Labs History",
            route: HealthPassportRoutesEnum.MY_LABS_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.MY_PHARMACY_HISTORY,
        element: <MyPharmacyHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "My Pharmacy History",
          }),
          crumb: () => ({
            title: "My Pharmacy History",
            route: HealthPassportRoutesEnum.MY_PHARMACY_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.MY_PROVIDER_HISTORY,
        element: <MyProviderHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "My Provider History",
          }),
          crumb: () => ({
            title: "My Provider History",
            route: HealthPassportRoutesEnum.MY_PROVIDER_HISTORY,
          }),
        },
      },
      {
        path: HealthPassportPathsEnum.PAST_MEDICAL_PROCEDURE_HISTORY,
        element: <PastMedicalProceduresHistoryPageLazy />,
        handle: {
          meta: () => ({
            title: "Past Medical Procedures History",
          }),
          crumb: () => ({
            title: "Past Medical Procedures History",
            route: HealthPassportRoutesEnum.FOOT_EXAM_HISTORY,
          }),
        },
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default HealthPassportRoutes;
